import { render } from "./SerialDetail.vue?vue&type=template&id=91d63322&scoped=true"
import script from "./SerialDetail.vue?vue&type=script&lang=js"
export * from "./SerialDetail.vue?vue&type=script&lang=js"

import "./SerialDetail.vue?vue&type=style&index=0&id=91d63322&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d63322"]])

export default __exports__